import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useDemographics } from "~/sdks/LocalDemographics/context";

import { DemographicsTextCard } from "~/components/DemographicsTextCard";

import * as styles from "../../styles";

export const AverageIncome = () => {
  const { t } = useTranslation("localDemographics");
  const {
    demographicsState: { income },
  } = useDemographics();

  const incomeTypes = useMemo(
    () =>
      income?.variables.slice().reverse() || [
        {
          variable: "avg_individual_income",
          label: "Avg individual income",
          value:
            income?.variables?.find((x) => x.variable === "inc_person")
              ?.value || 0.0,
        },
        {
          variable: "avg_household_income",
          label: "Avg household income",
          value:
            income?.variables?.find((x) => x.variable === "inc_home")?.value ||
            0.0,
        },
      ],
    [income?.variables]
  );

  /**
   * Intl.NumberFormat does a good job at displaying currency.
   *
   * We USD for the currency so that it formats to have a $ at the start of the amount.
   * If we put CAD, it will output as CAD$
   */
  const chartOptions = useMemo(
    () => ({
      options: {
        title: t("data.income.graphs.averageIncome.title"),
        values: incomeTypes.map((incomeType) => ({
          variable: incomeType.variable,
          value: `${new Intl.NumberFormat("en-EN", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 1,
          }).format(incomeType.value / 1000)}${
            incomeType.value >= 1000 ? "k" : ""
          }`,
          label: t(
            `data.income.graphs.averageIncome.types.${incomeType.variable as "avg_household_income" | "avg_individual_income"}`
          ),
        })),
      },
    }),
    [incomeTypes]
  );

  return (
    <div className={styles.cardContainer}>
      <DemographicsTextCard {...chartOptions} />
    </div>
  );
};
